import React from 'react';
import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api';

const containerStyle = { width: '100%', height: '420px', borderRadius: '12px' };
const defaultCenter = { lat: 29.3759, lng: 47.9774 };
const libraries = ['places'];

export default function MapView({ markers = [] }) {
    const key = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: key,
        libraries
    });

    if (!key) {
        return (
            <div className="rounded-xl border p-4 text-sm text-red-600 bg-red-50">
                Google Maps API key is missing. Set <code>VITE_GOOGLE_MAPS_API_KEY</code> and rebuild the frontend.
            </div>
        );
    }

    if (loadError) {
        return (
            <div className="rounded-xl border p-4 text-sm text-red-600 bg-red-50">
                Failed to load Google Maps: {String(loadError.message || loadError)}
            </div>
        );
    }

    if (!isLoaded) return <div>Loading map…</div>;

    return (
        <GoogleMap mapContainerStyle={containerStyle} center={defaultCenter} zoom={12}>
            {markers.map((m, i) => (
                <Marker key={i} position={{ lat: m.lat, lng: m.lng }} title={m.name} />
            ))}
        </GoogleMap>
    );
}
